import { BenchmarkDiagramSeries } from '../../benchmarks/benchmarks-model';
import { DriverType } from '../driver-types/driver-type';
import { DimensionName } from './dimension-name';
import { Subtotal  }  from './subtotal';

export class CardLocation {
    public tabId: number;
    public cardIndex: number;
}

export class AltCardView {
    public formCompOldVal: number;
    public formCompNewVal: number;
    public formCompPerc: number;
    public formCompAbsPerc: number;
    public outcomeOldVal: number;
    public outcomeNewVal: number;
    public diagramSeries: BenchmarkDiagramSeries[];
}

export enum FcstWalkCardType {
    Precedent,
    Set,
    Group,
}

export class Card {
    public cardType: FcstWalkCardType;
    public allDimensions: string[];
    public driverType : DriverType;
    public formulaComponentIndex: number;

    public driverId: any;
    public driverName: string;
    public seqDriverValue: number;
    public seqPercentValue: number;
    public absDriverValue: number;
    public absPercentValue: number;
    public dimensions: DimensionName[];

    get visibleDimensions(): DimensionName[] {
        return this.dimensions.slice(0, 4);
    }
    get hiddenDimensions(): DimensionName[] {
        return this.dimensions.slice(4);
    }

    public isLocked: boolean;
    public subtotal: Subtotal;

    public isExplodable: boolean = true;

    public cardLocation: CardLocation;

    //waterfall chart vals:
    public seqChartColorSeqMode: string;
    public seqChartColorAbsMode: string;
    public seqChartDiff: number;
    public absChartColor: string;
    public absChartDiff: number;
    public seqChartDiffWithOutOfScope: number;
    public seqChartColorSeqModeWithOutOfScope: string;
    public seqChartColorAbsModeWithOutOfScope: string;
    public absChartDiffWithOutOfScope: number;
    public absChartColorWithOutOfScope: string;

    public confidenceColor: string;
    public confidenceUnavailable: boolean;

    public addOutOfScopeCardToParentAvailable: boolean;

    //alt card view:
    public altViewSeq: AltCardView;
    public altViewTot: AltCardView;
    public formCompWeightSettingName: string;
    public driverNameForAltView: string;

    public showAltView: boolean;
    public selectedDiagram: BenchmarkDiagramSeries;
    public diagramComboOpened: boolean;
    public showInlineButtons: boolean;

    //fancy pipe contexts:    
    public formCompCtx: any;
    public outcomeCtx: any;
    public diagramMinMaxCtx: any;
    public diagramValsCtx: any;

    public markedForBulkRemove: boolean;
    public markedForBulkAddToParent: boolean;
    public markedForBulkCollapse: boolean;
    public markedForBulkRequestStory: boolean;

    public recommendedBreakdownDims: number[] | null;

    //for fcst walk
    public cardPath: number[];
}
